import { render } from "./AppOrariGara.vue?vue&type=template&id=2875bc4e"
const script = {}

import "./AppOrariGara.vue?vue&type=style&index=0&id=2875bc4e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__